(function () {
  "use strict";

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function headerEl() {
    var header = document.querySelector(".header");
    if (!header) return null;
    var section = header.closest(".shopify-section");
    if (section) {
      var sectionPos = window.getComputedStyle(section).position;
      if (sectionPos === "sticky" || sectionPos === "fixed") return section;
    }
    var parent = header.parentElement;
    if (parent && window.getComputedStyle(parent).position === "sticky") return parent;
    return header;
  }

  var offsetTick = 0;
  function setHeaderOffset() {
    if (offsetTick) return;
    offsetTick = window.requestAnimationFrame(function () {
      offsetTick = 0;
      var el = headerEl();
      var height = 0;
      if (el) {
        var rect = el.getBoundingClientRect();
        var pos = window.getComputedStyle(el).position;
        if ((pos === "fixed" || pos === "sticky") && rect.top <= 1) {
          height = Math.max(0, Math.round(rect.bottom));
        } else {
          height = Math.round(rect.height);
        }
      }
      document.documentElement.style.setProperty("--wcd-header-offset", height + "px");
      document.body.style.setProperty("--wcd-header-offset", height + "px");
      var nav = document.querySelector(".wcd-nav");
      if (nav) {
        var navSection = nav.closest(".shopify-section");
        if (navSection) navSection.classList.add("wcd-nav-section");
        var navHeight = Math.round(nav.getBoundingClientRect().height) + "px";
        document.documentElement.style.setProperty("--wcd-nav-height", navHeight);
        document.body.style.setProperty("--wcd-nav-height", navHeight);
      }
    });
  }

  function scrollToId(id) {
    if (!id || id === "#") return;
    var target = document.querySelector(id);
    if (!target || target.hidden) return;
    target.scrollIntoView({ behavior: reduceMotion() ? "auto" : "smooth", block: "start" });
  }

  function updatesPanel() {
    return document.getElementById("updates-wrap");
  }

  function setSectionHidden(el, hidden) {
    if (!el) return;
    var wrap = el.closest(".shopify-section") || el;
    wrap.hidden = !!hidden;
    el.hidden = !!hidden;
    if ("inert" in wrap) wrap.inert = !!hidden;
    if ("inert" in el) el.inert = !!hidden;
  }

  function applyWcdView(open) {
    document.querySelectorAll('[data-wcd-view="campaign"]').forEach(function (el) {
      setSectionHidden(el, open);
    });
    var panel = updatesPanel();
    if (panel) setSectionHidden(panel, !open);
  }

  function afterLayout(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  function setUpdatesOpen(open, opts) {
    opts = opts || {};
    var panel = updatesPanel();
    var body = document.body;
    if (!panel || !body) return;
    body.classList.toggle("is-updates-open", !!open);
    body.setAttribute("data-wcd-view", open ? "updates" : "campaign");
    applyWcdView(!!open);
    if (open) {
      setNavActive("#updates");
      if (opts.history !== false) {
        if (location.hash !== "#updates") history.pushState({ wcdView: "updates" }, "", "#updates");
        else if (history.replaceState) history.replaceState({ wcdView: "updates" }, "", "#updates");
      }
      if (opts.scroll !== false) {
        afterLayout(function () {
          scrollToId("#updates-wrap");
          var heading = document.getElementById("wcd-updates-heading");
          if (heading && heading.focus) heading.focus({ preventScroll: true });
        });
      }
    } else {
      if (opts.history !== false && location.hash === "#updates") {
        history.pushState({ wcdView: "campaign" }, "", location.pathname + location.search);
      }
      if (opts.scrollTo) {
        afterLayout(function () {
          setNavActive(opts.scrollTo);
          scrollToId(opts.scrollTo);
        });
      }
    }
  }

  function setNavActive(href) {
    document.querySelectorAll(".wcd-nav a[href^='#']").forEach(function (link) {
      var on = link.getAttribute("href") === href;
      if (on) link.setAttribute("aria-current", "true");
      else link.removeAttribute("aria-current");
      if (link.parentElement) link.parentElement.classList.toggle("is-active", on);
    });
  }

  function bindAnchors() {
    document.querySelectorAll(".wcd-page a[href^='#']").forEach(function (link) {
      if (link.dataset.wcdAnchorBound === "1") return;
      link.dataset.wcdAnchorBound = "1";
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href");
        if (!id || id === "#") return;
        if (id === "#updates") {
          event.preventDefault();
          event.stopPropagation();
          setUpdatesOpen(true);
          return;
        }
        var target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        setUpdatesOpen(false, { scrollTo: id });
      });
    });
  }

  function bindNav() {
    var nav = document.querySelector(".wcd-nav");
    if (!nav || nav.dataset.wcdNavBound === "1") return;
    nav.dataset.wcdNavBound = "1";
    nav.addEventListener("click", function (event) {
      var updates = event.target.closest('a[href="#updates"], [data-mayekoo-updates-nav-target]');
      if (updates) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        setUpdatesOpen(true);
        return;
      }
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute("href");
      if (!id || id === "#") return;
      event.preventDefault();
      event.stopPropagation();
      setUpdatesOpen(false, { scrollTo: id });
    }, true);

    document.querySelectorAll("[data-wcd-close-updates]").forEach(function (button) {
      if (button.dataset.wcdCloseBound === "1") return;
      button.dataset.wcdCloseBound = "1";
      button.addEventListener("click", function () {
        setUpdatesOpen(false, { scrollTo: "#the-day" });
      });
    });
  }

  function bindHistory() {
    if (bindHistory.bound) return;
    bindHistory.bound = true;
    window.addEventListener("popstate", function () {
      setUpdatesOpen(location.hash === "#updates", { history: false, scroll: location.hash === "#updates" });
    });
  }

  function bindScrollspy() {
    var navLinks = Array.prototype.slice.call(
      document.querySelectorAll(".wcd-nav a[href^='#']")
    ).filter(function (link) {
      return link.getAttribute("href") !== "#mayekoo-giving" && link.getAttribute("href") !== "#updates";
    });
    var sections = navLinks
      .map(function (link) { return document.querySelector(link.getAttribute("href")); })
      .filter(Boolean);
    if (!sections.length || bindScrollspy.bound) return;
    bindScrollspy.bound = true;
    function update() {
      if (document.body.classList.contains("is-updates-open")) return;
      var offset = parseInt(getComputedStyle(document.body).getPropertyValue("--wcd-header-offset"), 10) || 0;
      var navH = parseInt(getComputedStyle(document.body).getPropertyValue("--wcd-nav-height"), 10) || 58;
      var line = offset + navH + 20;
      var current = sections[0];
      sections.forEach(function (section) {
        if (section.getBoundingClientRect().top <= line) current = section;
      });
      if (current) setNavActive("#" + current.id);
    }
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function bindBeforeAfter() {
    var range = document.getElementById("wcd-ba-range");
    var after = document.getElementById("wcd-ba-after");
    var handle = document.getElementById("wcd-ba-handle");
    if (!range || !after || !handle) return;
    var sync = function () {
      after.style.clipPath = "inset(0 0 0 " + range.value + "%)";
      handle.style.left = range.value + "%";
    };
    range.addEventListener("input", sync);
    sync();
  }

  function bindVideoFacade() {
    var video = document.getElementById("wcd-2025-video");
    if (!video) return;
    var button = video.querySelector("[data-wcd-video-play]");
    if (!button) return;
    button.addEventListener("click", function () {
      var id = video.getAttribute("data-video-id") || "-Zx9jrA0DSg";
      video.innerHTML =
        '<iframe src="https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(id) +
        '?autoplay=1" title="World Cleanup Day 2025 — Laboma Beach" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;border:0"></iframe>';
      video.classList.add("is-playing");
    });
  }

  function bindMedia() {
    var items = Array.prototype.slice.call(document.querySelectorAll("[data-wcd-media]"));
    var lightbox = document.getElementById("wcd-lb");
    var stage = document.getElementById("wcd-lbi");
    var strip = document.getElementById("wcd-lbstrip");
    if (!lightbox || !stage) return;
    var current = 0;
    var lastFocus = null;

    var storyGrid = document.getElementById("wcd-photo-story-grid");
    var moreBtn = document.getElementById("wcd-photo-more");
    var storyExpanded = false;
    var storyFilter = "all";
    var storyResizeTimer = 0;

    function activeStoryFilter() {
      var on = document.querySelector(".wcd-chip.is-on");
      return (on && on.getAttribute("data-f")) || "all";
    }

    function tileMatchesFilter(tile, filter) {
      return filter === "all" || tile.getAttribute("data-tag") === filter;
    }

    function categoryItems() {
      var filter = storyFilter;
      return items.filter(function (item) {
        if (item.classList.contains("wcd-tile")) return tileMatchesFilter(item, filter);
        return item.style.display !== "none";
      });
    }

    function setTileFolded(tile, folded) {
      tile.classList.toggle("is-folded", folded);
      if (folded) {
        tile.setAttribute("aria-hidden", "true");
        tile.setAttribute("tabindex", "-1");
      } else {
        tile.removeAttribute("aria-hidden");
        tile.setAttribute("tabindex", "0");
      }
    }

    function updateMoreButton(hasOverflow) {
      if (!moreBtn) return;
      if (!hasOverflow) {
        moreBtn.hidden = true;
        moreBtn.classList.remove("is-visible");
        moreBtn.setAttribute("aria-expanded", "false");
        return;
      }
      moreBtn.hidden = false;
      moreBtn.classList.add("is-visible");
      moreBtn.setAttribute("aria-expanded", storyExpanded ? "true" : "false");
      moreBtn.textContent = storyExpanded ? "Show fewer photos ↑" : "Show more photos ↓";
    }

    function applyStoryFilter() {
      storyFilter = activeStoryFilter();
      document.querySelectorAll(".wcd-tile").forEach(function (tile) {
        tile.style.display = tileMatchesFilter(tile, storyFilter) ? "" : "none";
        setTileFolded(tile, false);
      });
    }

    function collapseStoryToThreeRows() {
      var matching = matchingStoryTiles();
      if (!matching.length || !storyGrid) {
        updateMoreButton(false);
        return;
      }
      var rowTops = storyRowTops(matching);
      var overflow = false;
      if (rowTops.length > 3) {
        var limit = rowTops[2];
        var gridTop = storyGrid.getBoundingClientRect().top;
        matching.forEach(function (tile) {
          var top = Math.round(tile.getBoundingClientRect().top - gridTop);
          if (top > limit + 8) {
            setTileFolded(tile, true);
            overflow = true;
          }
        });
      }
      updateMoreButton(overflow);
    }

    function matchingStoryTiles() {
      if (!storyGrid) return [];
      return Array.prototype.slice.call(storyGrid.querySelectorAll(".wcd-tile")).filter(function (tile) {
        return tile.style.display !== "none";
      });
    }

    function storyRowTops(tiles) {
      if (!storyGrid) return [];
      var gridTop = storyGrid.getBoundingClientRect().top;
      var rowTops = [];
      tiles.forEach(function (tile) {
        var top = Math.round(tile.getBoundingClientRect().top - gridTop);
        var found = false;
        for (var i = 0; i < rowTops.length; i += 1) {
          if (Math.abs(rowTops[i] - top) <= 8) {
            found = true;
            break;
          }
        }
        if (!found) rowTops.push(top);
      });
      rowTops.sort(function (a, b) { return a - b; });
      return rowTops;
    }

    function refreshStoryGrid(options) {
      var opts = options || {};
      applyStoryFilter();
      window.requestAnimationFrame(function () {
        if (storyExpanded) {
          var expandedRows = storyRowTops(matchingStoryTiles());
          if (expandedRows.length <= 3) {
            storyExpanded = false;
            updateMoreButton(false);
          } else {
            updateMoreButton(true);
          }
          return;
        }
        collapseStoryToThreeRows();
        if (opts.keepNearStory) {
          var heading = storyGrid && storyGrid.previousElementSibling;
          var anchor = heading || storyGrid;
          if (anchor && anchor.getBoundingClientRect().top < 80) {
            anchor.scrollIntoView({ block: "start", behavior: reduceMotion() ? "auto" : "smooth" });
          }
        }
      });
    }

    function renderThumb(item, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "wcd-lb__th" + (index === current ? " is-on" : "");
      button.setAttribute("aria-label", "Open " + (item.getAttribute("data-cap") || "media"));
      var thumb = item.querySelector("img");
      if (thumb) button.style.backgroundImage = 'url("' + thumb.src + '")';
      button.addEventListener("click", function () { show(index); });
      return button;
    }

    function show(index) {
      var visible = categoryItems();
      if (!visible.length) return;
      current = (index + visible.length) % visible.length;
      var item = visible[current];
      lastFocus = document.activeElement;
      stage.innerHTML = "";
      stage.className = "wcd-lb__img" + (item.getAttribute("data-kind") === "video" ? " is-vid" : "");
      var videoId = item.getAttribute("data-video-id");
      var src = item.getAttribute("data-src");
      if (item.getAttribute("data-kind") === "video" && videoId) {
        var frame = document.createElement("iframe");
        frame.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(videoId) + "?autoplay=1";
        frame.title = item.getAttribute("data-cap") || "Video";
        frame.allow = "autoplay; encrypted-media; picture-in-picture";
        frame.allowFullscreen = true;
        stage.appendChild(frame);
      } else if (src) {
        var image = document.createElement("img");
        image.src = src;
        image.alt = item.getAttribute("data-alt") || item.getAttribute("data-cap") || "";
        stage.appendChild(image);
      }
      var title = document.getElementById("wcd-lbt");
      var sub = document.getElementById("wcd-lbs");
      var count = document.getElementById("wcd-lbc");
      if (title) title.textContent = item.getAttribute("data-cap") || "";
      if (sub) sub.textContent = [item.getAttribute("data-tag"), item.getAttribute("data-cat"), item.getAttribute("data-credit"), item.getAttribute("data-meta")].filter(Boolean).join(" · ");
      if (count) count.textContent = current + 1 + " / " + visible.length;
      if (strip) {
        strip.innerHTML = "";
        categoryItems().forEach(function (entry, entryIndex) {
          strip.appendChild(renderThumb(entry, entryIndex));
        });
      }
      if (typeof lightbox.showModal === "function" && !lightbox.open) lightbox.showModal();
      lightbox.classList.add("is-open");
      document.body.style.overflow = "hidden";
      var close = document.getElementById("wcd-lbx");
      if (close) close.focus();
    }

    function close() {
      lightbox.classList.remove("is-open");
      if (lightbox.open && typeof lightbox.close === "function") lightbox.close();
      document.body.style.overflow = "";
      stage.innerHTML = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    items.forEach(function (item) {
      item.addEventListener("click", function () { show(categoryItems().indexOf(item)); });
      item.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          show(categoryItems().indexOf(item));
        }
      });
    });

    var closeBtn = document.getElementById("wcd-lbx");
    var prevBtn = document.getElementById("wcd-lbp");
    var nextBtn = document.getElementById("wcd-lbn");
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (prevBtn) prevBtn.addEventListener("click", function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { show(current + 1); });
    lightbox.addEventListener("cancel", function (event) {
      event.preventDefault();
      close();
    });
    document.addEventListener("keydown", function (event) {
      if (!lightbox.classList.contains("is-open")) return;
      if (event.key === "Escape") close();
      if (event.key === "ArrowLeft") show(current - 1);
      if (event.key === "ArrowRight") show(current + 1);
    });

    var share = document.getElementById("wcd-lbshare");
    if (share) {
      share.addEventListener("click", function () {
        var data = { title: document.title, url: location.href };
        if (navigator.share) navigator.share(data).catch(function () {});
        else if (navigator.clipboard) navigator.clipboard.writeText(data.url);
      });
    }

    document.querySelectorAll(".wcd-chip").forEach(function (chip) {
      chip.addEventListener("click", function () {
        document.querySelectorAll(".wcd-chip").forEach(function (other) {
          other.classList.remove("is-on");
          other.setAttribute("aria-pressed", "false");
        });
        chip.classList.add("is-on");
        chip.setAttribute("aria-pressed", "true");
        storyExpanded = false;
        refreshStoryGrid();
      });
    });
    var firstChip = document.querySelector(".wcd-chip.is-on");
    if (firstChip) firstChip.setAttribute("aria-pressed", "true");
    if (moreBtn) {
      moreBtn.addEventListener("click", function () {
        storyExpanded = !storyExpanded;
        refreshStoryGrid({ keepNearStory: !storyExpanded });
      });
    }
    window.addEventListener("resize", function () {
      window.clearTimeout(storyResizeTimer);
      storyResizeTimer = window.setTimeout(function () {
        refreshStoryGrid();
      }, 160);
    });
    refreshStoryGrid();
  }

  function bindKlaviyo() {
    var forms = document.querySelectorAll("[data-wcd-klaviyo]");
    if (!forms.length || !window.KlaviyoSubscribe) return false;
    forms.forEach(function (form) {
      if (form.getAttribute("data-wcd-klaviyo-bound") === "true") return;
      form.setAttribute("data-wcd-klaviyo-bound", "true");
      window.KlaviyoSubscribe.attachToForms("#" + form.id, {
        hide_form_on_success: true,
        success: function () {
          var status = form.querySelector("[data-wcd-nl-status]");
          var fields = form.querySelector("[data-wcd-nl-fields]");
          if (fields) fields.hidden = true;
          if (status) {
            status.hidden = false;
            status.innerHTML =
              "<strong>" +
              (form.getAttribute("data-mk-msg-success-h") || "Check your inbox.") +
              "</strong> " +
              (form.getAttribute("data-mk-msg-success-b") || "Please confirm your subscription to complete your signup.");
          }
        },
        extra_properties: {
          $source: form.getAttribute("data-mk-source") || "Mayekoo World Cleanup Day 2026",
          $method_type: "Klaviyo Form",
          $method_id: "wcd-email"
        }
      });
    });
    return true;
  }

  function bindKlaviyoValidation() {
    document.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-wcd-klaviyo]");
      if (!form) return;
      var email = form.querySelector('input[type="email"]');
      var value = email && email.value ? email.value.trim() : "";
      var status = form.querySelector("[data-wcd-nl-status]");
      function showError(message) {
        if (!status) return;
        status.hidden = false;
        status.textContent = message;
      }
      if (!value) {
        event.preventDefault();
        showError(form.getAttribute("data-mk-msg-required") || "Please enter your email address.");
        if (email) email.focus();
        return;
      }
      if (email && !email.checkValidity()) {
        event.preventDefault();
        showError(form.getAttribute("data-mk-msg-invalid") || "Please enter a valid email address.");
        email.focus();
      }
    });
  }

  function bindFaq() {
    document.querySelectorAll(".wcd-faq details").forEach(function (item) {
      if (item.dataset.wcdFaqBound === "1") return;
      item.dataset.wcdFaqBound = "1";
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        document.querySelectorAll(".wcd-faq details").forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function bindGivingFallback() {
    document.querySelectorAll("[data-evergreen-set-frequency]").forEach(function (trigger) {
      if (trigger.dataset.wcdFrequencyBound === "1") return;
      trigger.dataset.wcdFrequencyBound = "1";
      trigger.addEventListener("click", function () {
        var frequency = String(trigger.getAttribute("data-evergreen-set-frequency") || "").toLowerCase();
        if (frequency !== "monthly" && frequency !== "once") return;
        window.setTimeout(function () {
          var button = document.querySelector('[data-evergreen-frequency="' + frequency + '"]');
          if (button) button.click();
        }, 0);
      });
    });
  }

  function bindUpdatesCountFallback() {
    var targets = document.querySelectorAll("[data-mayekoo-updates-nav-target]");
    if (!targets.length) return;
    fetch("/apps/mayekoo-fundraising/updates?" + new URLSearchParams({ mode: "count", cause: "beach-cleanup" }), {
      headers: { Accept: "application/json" }
    })
      .then(function (response) { return response.json(); })
      .then(function (json) {
        if (!json || json.ok !== true) return;
        var label = "Updates (" + (Number(json.count) || 0) + ")";
        targets.forEach(function (target) {
          if (target.dataset.navBound === "1") return;
          target.textContent = label;
        });
      })
      .catch(function () {});
  }

  function watchPrivacyBanner() {
    var body = document.body;
    if (!body || !body.classList.contains("wcd-page") || watchPrivacyBanner.bound) return;
    watchPrivacyBanner.bound = true;
    function sync() {
      var banner = document.querySelector("#shopify-pc__banner, .shopify-pc__banner");
      var open = !!(banner && banner.offsetParent !== null && banner.getAttribute("hidden") == null);
      body.classList.toggle("wcd-page--banner-open", open);
      body.classList.toggle("wcd-page--has-mbar", window.matchMedia("(max-width: 760px)").matches);
    }
    sync();
    window.addEventListener("resize", sync);
    if (window.MutationObserver) {
      var observer = new MutationObserver(sync);
      observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
    }
  }

  var started = false;
  function init() {
    if (!document.body || !document.body.classList.contains("wcd-page")) return;
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    setHeaderOffset();
    bindAnchors();
    bindNav();
    bindHistory();
    bindScrollspy();
    bindBeforeAfter();
    bindVideoFacade();
    bindMedia();
    bindFaq();
    bindKlaviyoValidation();
    bindGivingFallback();
    bindUpdatesCountFallback();
    watchPrivacyBanner();
    if (!started) {
      started = true;
      window.addEventListener("resize", setHeaderOffset);
      window.addEventListener("orientationchange", setHeaderOffset);
      if (location.hash === "#updates") setUpdatesOpen(true, { scroll: true });
      else if (location.hash === "#mayekoo-giving") {
        requestAnimationFrame(function () { scrollToId("#mayekoo-giving"); });
      }
    }
    if (!bindKlaviyo()) {
      var script = document.querySelector('script[src*="klaviyo_subscribe.js"]');
      if (script) script.addEventListener("load", bindKlaviyo);
      window.setTimeout(bindKlaviyo, 1200);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
